"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TimeoutScheduler_1 = require("./TimeoutScheduler");
/**
 * [[AsyncScheduler]] enqueues the callback for the soonest available run of the
 * event loop.
 */


var AsyncScheduler = /*#__PURE__*/function (_TimeoutScheduler_1$d) {
  _inherits(AsyncScheduler, _TimeoutScheduler_1$d);

  var _super = _createSuper(AsyncScheduler);

  function AsyncScheduler() {
    _classCallCheck(this, AsyncScheduler);

    return _super.call(this, 0);
  }
  /**
   * Execute the provided callback on the next tick of the event loop.
   * This is semantically equivalent to
   *
   * ```typescript
   * new AsyncScheduler(callback).start();
   * ```
   *
   * but with less overhead.
   *
   * @param callback the code to run.
   */


  _createClass(AsyncScheduler, null, [{
    key: "nextTick",
    value: function nextTick(callback) {
      setTimeout(callback, 0);
    }
  }]);

  return AsyncScheduler;
}(TimeoutScheduler_1.default);

exports.default = AsyncScheduler;